import { render, staticRenderFns } from "./TiposTurno.vue?vue&type=template&id=f4dd597e&scoped=true"
import script from "./TiposTurno.vue?vue&type=script&lang=js"
export * from "./TiposTurno.vue?vue&type=script&lang=js"
import style0 from "./TiposTurno.vue?vue&type=style&index=0&id=f4dd597e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dd597e",
  null
  
)

export default component.exports